import { render, staticRenderFns } from "./PhieuKhamBenh.vue?vue&type=template&id=3493901b&scoped=true"
import script from "./PhieuKhamBenh.vue?vue&type=script&lang=js"
export * from "./PhieuKhamBenh.vue?vue&type=script&lang=js"
import style0 from "./PhieuKhamBenh.vue?vue&type=style&index=0&id=3493901b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3493901b",
  null
  
)

export default component.exports